<template>
    <div :class="fieldClass">
        <label v-if="label" class="form-field__label">
            {{ label }}

            <common-info-tip v-if="hint || $slots.hint">
                <slot name="hint">
                    <span v-html="hint"></span>
                </slot>
            </common-info-tip>

            <p v-if="$slots.right" class="form-field__right">
                <slot name="right"></slot>
            </p>
        </label>

        <div class="form-field__input">
            <slot></slot>
            <div v-if="$slots.icon" class="form-field__input_icon">
                <slot name="icon"></slot>
            </div>
        </div>

        <div v-if="error || $slots.error" class="form-field__error">
            <common-icon name="forbidden" size="medium"></common-icon>

            <p>
                <slot name="error" :error="error">
                    {{ error }}
                </slot>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            label: { type: String, default: undefined },
            hint: { type: String, default: undefined },
            error: { type: [Object, String], default: undefined },
            isInline: { type: Boolean, default: false },
            isDisabled: { type: Boolean, default: false },
            isHidden: { type: Boolean, default: false },
        },

        computed: {
            fieldClass() {
                return {
                    'form-field': true,
                    'form-field--is-inline': this.isInline,
                    'form-field--is-disabled': this.isDisabled,
                    'form-field--is-hidden': this.isHidden,
                }
            },
        },
    }
</script>
